import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ParamsCalendarItemId = {
  calendar_item_id: string;
};

export type ProgramsProgramCohortCalendarItemModel =
  ProgramsProgramCohortModel & ParamsCalendarItemId;

export default class ProgramsProgramCohortCalendarItemRoute extends Route<ProgramsProgramCohortCalendarItemModel> {
  @service declare store: Store;

  model(params: ParamsCalendarItemId) {
    return {
      ...(this.modelFor(
        'programs.program.cohort.content'
      ) as ProgramsProgramCohortModel),
      ...params,
    };
  }
}
